import React from 'react';

const Timeline = ({ datesData }) => {
  
  const milestones = [
    { key: 'date_init', label: 'Init' },
    { key: 'date_inbound', label: 'Inbound' },
    { key: 'date_pedimento_paid', label: 'Paid' },
    { key: 'date_doda', label: 'DODA' },
    { key: 'date_loading_order', label: 'LO' },
    { key: 'date_init_loading', label: 'IL' },
    { key: 'date_init_unloading', label: 'IU' },
    { key: 'date_yard_outbound', label: 'Yard Out' },
    { key: 'date_crossing', label: 'Crossing' },
    { key: 'date_end', label: 'End' },
  ];

  const isMilestoneReached = (dateKey) => {
    const dateValue = datesData[dateKey];
    return dateValue !== null && dateValue !== undefined && dateValue !== "";
  };

  const getCircleColor = (dateKey) => {
    return isMilestoneReached(dateKey) ? 'bg-blue-500 border-blue-700' : 'bg-white border-blue-300';
  };

  const getLineColor = (currentIndex) => {
    if (currentIndex === 0 || !isMilestoneReached(milestones[currentIndex - 1].key) || !isMilestoneReached(milestones[currentIndex].key)) {
      return 'bg-blue-200';
    }
    return 'bg-blue-500';
  };

  return (
    <div className="flex items-center pt-4 pb-4 bg-white w-full">
      {milestones.map((milestone, index) => (
        <React.Fragment key={index}>
          <div className="flex flex-col items-center flex-shrink-0 relative" style={{ height: '90px' }}>
            <div className={`w-6 h-6 rounded-full border-2 ${getCircleColor(milestone.key)} absolute top-1/2 transform -translate-y-1/2`}></div>
            <span className="text-xs text-center w-28 absolute top-1/2 mt-7 transform -translate-y-1/2 text-blue-800">{milestone.label}</span>
          </div>
          {index !== milestones.length - 1 && (
            <div className={`flex-grow h-1.5 ${getLineColor(index)} mx-2`}></div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Timeline;